import React, { useState, useContext, useEffect, useCallback } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../App.css";
import CartContext from "../Context/CartContext/CartContext";
import emailjs from "@emailjs/browser";
import { DotLoader } from "react-spinners";

function FormTwo({ GetToNextPage }) {
  const Rooms = [
    { id: 1, name: "DOUBLE ROOM", total: 2 },
    { id: 2, name: "EXECUTIVE ROOM", total: 2 },
    { id: 3, name: "TWIN ROOM", total: 2 },
    { id: 4, name: "TRIPLE ROOM", total: 3 },
  ];
  const { cartAction, cart } = useContext(CartContext);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState();
  // console.log(
  //   "The local cart is",
  //   JSON.parse(localStorage.getItem("LocalCart"))
  // );

  //const [booking, setBooking] = useState([]);

  const AddBooking = (data) => {
    const unique_id = Math.round(Date.now() / 1000);
    const item = { id: unique_id, rt: 1, ga: 0, gk: 0, lm: 2 };
    cartAction(2, item);
    //setBooking([...booking, { id: unique_id, rt: 1, ga: 0, gk: 0 }]);
  };

  const RemoveELementArray = (item) => {
    console.log("Removing", item);
    cartAction(0, item);
    //window.location.reload();
  };

  const ClearCart = () => {
    localStorage.removeItem("LocalCart");
    window.location.reload();
  };

  console.log(JSON.parse(localStorage.getItem("ClientData")));

  useEffect(() => emailjs.init("b4pLRGOVqOi-CuvTi"), []);
  const sendEmail = (e) => {
    e.preventDefault();

    const Client = JSON.parse(localStorage.getItem("ClientData"));

    const clientMessage =
      Client.message +
      "\n" +
      "\n" +
      "Client Full Name ; " +
      Client.fullName +
      "\n" +
      "Client Phone Number ; " +
      Client.phone +
      "\n" +
      "Client Check In Time ; " +
      Client.checkIn +
      "\n" +
      "Client Check Out Time ; " +
      Client.checkOut +
      "\n" +
      "\n";

    const messageOne = cart[0]
      ? "Room Type : " +
        " " +
        cart[0].rt +
        " " +
        " Adults : " +
        " " +
        cart[0].ga +
        " " +
        "Adults : " +
        cart[0].gk
      : "";

    const messageTwo = cart[1]
      ? "Room Type : " +
        " " +
        cart[1].rt +
        " " +
        " Adults : " +
        " " +
        cart[1].ga +
        " " +
        "Adults : " +
        cart[1].gk
      : "";
    const messageThree = cart[2]
      ? "Room Type : " +
        " " +
        cart[2].rt +
        " " +
        " Adults : " +
        " " +
        cart[2].ga +
        " " +
        "Adults : " +
        cart[2].gk
      : "";
    const messageFour = cart[3]
      ? "Room Type : " +
        " " +
        cart[3].rt +
        " " +
        " Adults : " +
        " " +
        cart[3].ga +
        " " +
        "Adults : " +
        cart[3].gk
      : "";
    const messageFive = cart[4]
      ? "Room Type : " +
        " " +
        cart[4].rt +
        " " +
        " Adults : " +
        " " +
        cart[4].ga +
        " " +
        "Adults : " +
        cart[4].gk
      : "";
    const messageSix = cart[5]
      ? "Room Type : " +
        " " +
        cart[5].rt +
        " " +
        " Adults : " +
        " " +
        cart[5].ga +
        " " +
        "Adults : " +
        cart[5].gk
      : "";
    const messageSeven = cart[6]
      ? "Room Type : " +
        " " +
        cart[6].rt +
        " " +
        " Adults : " +
        " " +
        cart[6].ga +
        " " +
        "Adults : " +
        cart[6].gk
      : "";
    const messageEight = cart[7]
      ? "Room Type : " +
        " " +
        cart[7].rt +
        " " +
        " Adults : " +
        " " +
        cart[7].ga +
        " " +
        "Adults : " +
        cart[7].gk
      : "";
    const messageNine = cart[8]
      ? "Room Type : " +
        " " +
        cart[8].rt +
        " " +
        " Adults : " +
        " " +
        cart[8].ga +
        " " +
        "Adults : " +
        cart[8].gk
      : "";
    const messageTen = cart[9]
      ? "Room Type : " +
        " " +
        cart[9].rt +
        " " +
        " Adults : " +
        " " +
        cart[9].ga +
        " " +
        "Adults : " +
        cart[9].gk
      : "";
    const messageEleven = cart[10]
      ? "Room Type : " +
        " " +
        cart[10].rt +
        " " +
        " Adults : " +
        " " +
        cart[10].ga +
        " " +
        "Adults : " +
        cart[10].gk
      : "";

    const message =
      clientMessage +
      "\n" +
      "ROOMS" +
      "\n" +
      messageOne +
      "\n" +
      messageTwo +
      "\n" +
      messageThree +
      "\n" +
      messageFour +
      "\n" +
      messageFive +
      "\n" +
      messageSix +
      "\n" +
      messageSeven +
      "\n" +
      messageEight +
      "\n" +
      messageNine +
      "\n" +
      messageTen +
      "\n" +
      messageEleven;

    setLoading(true);
    emailjs
      .send("service_nxoxt0v", "template_xa64265", {
        message: message,
        from_name: Client.fullName,
        reply_to: Client.email,
      })
      .then(
        () => {
          localStorage.removeItem("LocalCart");
          setLoading(false);
          setResult("success");
          console.log("SUCCESS!");
          localStorage.removeItem("ClientData");
        },
        (error) => {
          setLoading(false);
          setResult("fail");
          console.log("FAILED...", error.text);
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        }
      );
  };

  return (
    <div>
      <Col xxl={8} className="Left_Container">
        {loading && (
          <div className="Loading_Overlay">
            <div className="Loading_Box">
              <DotLoader
                color={"#fff"}
                loading={loading}
                //cssOverride={override}
                size={50}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
              <span>SUBMITING</span>
            </div>
          </div>
        )}
        {result && (
          <div className="Loading_Overlay">
            <div className="Loading_Box">
              <span>
                {result === "success" ? "SUCCESSFULLY!" : "FAILED, TRY AGAIN!"}
              </span>
            </div>
          </div>
        )}
        <div className="Header_Box">
          <h4 className="Header_Text">ROOMS</h4>
        </div>

        {cart.length > 0 && (
          <div className="Room_Container">
            {cart.map((item, index) => {
              return (
                <RoomForm
                  cartAction
                  key={index}
                  RemoveElement={RemoveELementArray}
                  BookingBox={item}
                  rooms={Rooms}
                />
              );
            })}
          </div>
        )}
        <div className="Action_Btn_Box">
          <Button
            disabled={cart.length > 0 ? false : true}
            className="Action_Btn"
            variant="primary"
            onClick={() => ClearCart()}
          >
            Clear Form
          </Button>
          <Button
            disabled={cart.length === 5 ? true : false}
            className="Action_Btn"
            variant="primary"
            onClick={() => AddBooking("div")}
          >
            Add Room
          </Button>
        </div>
        <div className="Form_Btn_Box">
          <Button
            className="Submit_Btn"
            variant="primary"
            onClick={() => GetToNextPage(1)}
          >
            PREVIOUSLY PAGE
          </Button>
          <Button
            disabled={cart.length > 0 ? false : true}
            className="Submit_Btn"
            variant="primary"
            onClick={sendEmail}
          >
            SUBMIT YOUR ENQUIRIES
          </Button>
        </div>
      </Col>
    </div>
  );
}

export default FormTwo;

function RoomForm(props) {
  const [kids, setKids] = useState(props.BookingBox.gk);
  const [adults, setAdults] = useState(props.BookingBox.ga);
  const [limit, setlimit] = useState(props.BookingBox.lm);
  const { cartAction } = useContext(CartContext);
  const [roomId, SetRoomId] = useState(props.BookingBox.rt);
  //const [item, setItem] = useState();

  const HandleChange = (e) => {
    let roomLimit = e.target.value;
    //let id = e.target.value[0];
    const roomData = props.rooms.find((room) => room.id === Number(roomLimit));
    //console.log(roomLimit, roomData);
    setlimit(Number(roomData.total));
    SetRoomId(Number(roomData.id));
  };

  const HandleRemove = (bookbox) => {
    console.log(bookbox);
    //props.RemoveElement(bookbox);
    cartAction(0, bookbox);
    window.location.reload();
  };

  //Update cart item on change of cart listing

  useEffect(() => {
    const UpdateCart = () => {
      const roomtype = roomId;
      const guestadult = adults;
      const guestkids = kids;
      const item = {
        id: props.BookingBox.id,
        rt: Number(roomtype),
        ga: Number(guestadult),
        gk: Number(guestkids),
        lm: Number(limit),
      };
      cartAction(2, item);
    };
    UpdateCart();
  }, [kids, adults, roomId, limit, props.BookingBox?.id]);

  return (
    <div className="Room_Box">
      <Form className="Room_Doc">
        <Row>
          <Col xxl={4} xl={4} xs={12} sm={12}>
            <Form.Group className="mb-2 form_input" controlId="formBasicEmail">
              <Form.Label className="Input_label">Room Type</Form.Label>
              <Form.Select
                onChange={HandleChange}
                defaultValue={props.BookingBox.rt}
                size="lg"
                width={200}
                className="form_input"
                controlId="formBasicEmail"
              >
                <option selected>Select room option</option>
                {props.rooms.map((room, index) => {
                  return (
                    <option key={index} value={room.id}>
                      {room.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xxl={4} xl={4} xs={12} sm={12}>
            <Form.Group className="mb-2 form_input" controlId="formBasicEmail">
              <Form.Label className="Input_label">Adults</Form.Label>
              <Form.Control
                size="lg"
                min={0}
                onChange={(e) => setAdults(e.target.value)}
                max={limit - kids}
                type="number"
                value={
                  limit - kids === 0 && props.BookingBox.ga === 0 ? 0 : adults
                }
                defaultValue={props.BookingBox.ga}
                placeholder="Number of Adults"
              />
            </Form.Group>
          </Col>
          <Col xxl={4} xl={4} xs={12} sm={12}>
            <Form.Group className="mb-2 form_input" controlId="formBasicEmail">
              <Form.Label className="Input_label">kids</Form.Label>
              <Form.Control
                size="lg"
                min={0}
                onChange={(e) => setKids(e.target.value)}
                max={limit - adults}
                value={
                  limit - adults === 0 && props.BookingBox.gk === 0 ? 0 : kids
                }
                defaultValue={props.BookingBox.gk}
                type="number"
                placeholder="Number of kids"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* <Button variant="primary" type="submit">
        Submit
      </Button> */}
      </Form>

      <button
        onClick={() => HandleRemove(props.BookingBox)}
        className="Remove_Btn"
      >
        <i class="bi bi-trash3"></i>
      </button>
    </div>
  );
}
